// extracted by mini-css-extract-plugin
export default {"backgroundBox":"box_backgroundBox__UoFN6","titleBox":"box_titleBox__791rr"};